import React from 'react';
import { Shield, ThumbsUp, Zap, Award } from 'lucide-react';

const Differentials = () => {
  const differentials = [
    {
      icon: <Award className="w-12 h-12" />,
      title: 'Mais de 20 anos de experiência',
      description: 'Tradição e conhecimento técnico desde 2004',
    },
    {
      icon: <Zap className="w-12 h-12" />,
      title: 'Atendimento rápido via WhatsApp',
      description: 'Resposta ágil e visita técnica sem compromisso',
    },
    {
      icon: <Shield className="w-12 h-12" />,
      title: 'Equipe especializada',
      description: 'Profissionais qualificados e projetos sob medida',
    },
    {
      icon: <ThumbsUp className="w-12 h-12" />,
      title: 'Acabamento premium',
      description: 'Materiais de alta qualidade e atenção aos detalhes',
    },
  ];

  return (
    <section className="section-padding-small bg-[var(--bg-secondary)]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">Por que escolher a Forti Vidros?</h2>
          <p className="body-regular text-[var(--text-secondary)]">
            Diferenciais que fazem toda a diferença no resultado final
          </p>
        </div>

        {/* Differentials Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="text-center fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full text-[var(--accent-gold)] mb-6 hover-lift">
                {item.icon}
              </div>
              <h3 className="heading-3 mb-3">{item.title}</h3>
              <p className="body-small text-[var(--text-secondary)]">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentials;
